import {
  ConfirmationBox,
  HeadingGroup,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import EmptyData from "../../Global/EmptyData";
import AddPopularSearch from "./AddPopularSearch";
import OrderColumn from "../../Global/OrderColumn";
import usePopularSearch from "./usePopularSearch";

const PopularSearch = () => {
  const {
    isLoading,
    isFetching,
    popularSearchList,
    showEditModal,
    popularSearchState,
    paginationOptions,
    handleEditColumnsClick,
    updatePopularSearchFields,
    handleDeleteModal,
    handleDelete,
    handleCreateClick,
    handlePagination,
    handleClearClick,
    handleEditAction,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  } = usePopularSearch();

  return (
    <div>
      <HeadingGroup
        title={"Popular Search"}
        className={`pro-mb-4`}
        buttonTitle={popularSearchList?.create_permission && "Create"}
        handleClick={handleCreateClick}
      />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={popularSearchState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: popularSearchState?.search }}
          handleActionClick={handleEditColumnsClick}
        />
        {popularSearchList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={popularSearchList?.data?.result || []}
            uniqueID={"_id"}
            fields={popularSearchList?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            deleteIcon={
              <span className="material-symbols-outlined">delete</span>
            }
            handleSort={handleSort}
            getRow={getRow}
            clear={popularSearchState?.clearSelection}
            loading={isFetching}
            perpage={popularSearchState?.currentPageSize}
            assignable={false}
            handleEdit={handleEditAction}
            handleDelete={handleDeleteModal}
            deletable={popularSearchList?.delete_permission}
            editable={popularSearchList?.edit_permission}
            showCheckBox={
              popularSearchList?.delete_permission ||
              popularSearchList?.edit_permission
            }
          />
        )}

        {popularSearchList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={popularSearchState?.currentPage}
            totalPageCount={Math.ceil(
              popularSearchList?.data?.total_count / popularSearchState.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === popularSearchState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={popularSearchState?.showDeleteModal}
          handleClose={handleDeleteModal}
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={"Are you sure to delete the selected popular search ?"}
              subTitle={"This action can't be undo "}
              cancelText={"No"}
              cancelAction={handleDeleteModal}
              submitText={"Yes"}
              submitAction={handleDelete}
              isRight={true}
            />
          </div>
        </ModalLayout>

        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetch={refetch}
              tableFields={popularSearchList?.fields || []}
              moduleId={popularSearchList?.module_id}
              updateData={updatePopularSearchFields}
            />
          </div>
        </ModalLayout>
        <OffCanvasLayout
          show={popularSearchState?.showCreateModal}
          handleClose={handleCreateClick}
          title={popularSearchState?.isEdit ? "Update Popular Search" : "Add Popular Search"}
          backdrop={"static"}
        >
          <AddPopularSearch
            refetch={refetch}
            handleCreateClick={handleCreateClick}
            isStickyFooter
          />
        </OffCanvasLayout>
      </div>
    </div>
  );
};

export default PopularSearch;
